import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const CashReceiptGuideContainer = styled.ul`
  display: flex;
  flex-direction: column;

  margin-top: -12px;
  gap: 2px;
`;

export const CashReceiptGuideItem = styled.li`
  display: flex;
  gap: 4px;
  font-size: 11.8px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.gray400};
`;
